<div class="modal failure-modal">
  <div class="model-container">
    <img src="/assets/img/error.svg" width="64" height="64" class="failure-icon" alt="failure">
    <div class="modal-body">
      <h3>{{data?.title || ('failure-modal.sth-went-wrong' | translate)}}</h3>
      <h5 class="msg">{{data?.msg}}</h5>
      <div class="modal-actions">
        <button class="button primary" aria-label="Try Again" (click)="closeDialog(true)" translate>{{data?.buttonText ||
          'failure-modal.try-again'}}</button>
      </div>
    </div>
  </div>
</div>